export default __webpack_public_path__ + "static/media/unpolluted-soil.13a4f61c.png";